import * as yup from "yup";

import { EMAIL_REGEX } from "@helpers/regex";

export const smtpSchema = yup.object({
    option: yup.string().oneOf(["other", "gmail", "outlook"]).required(),
    server: yup.string().when("option", {
        is       : "other",
        then     : (s) => s.trim().required("SMTP Server is required"),
        otherwise: (s) => s.notRequired()
    }),
    username: yup.string().when("option", {
        is       : "other",
        then     : (s) => s.trim().required("SMTP Username is required"),
        otherwise: (s) => s.notRequired()
    }),
    rate_limit: yup.string(),
    from_name : yup.string().trim().required("From Email Name is required"),
    email     : yup.string().when("option", {
        is       : "other",
        then     : (s) => s.trim().required("Email is required").matches(EMAIL_REGEX.pattern, EMAIL_REGEX.msg),
        otherwise: (s) => s.notRequired()
    }),
    port: yup.string().when("option", {
        is       : "other",
        then     : (s) => s.trim().required("Port is required"),
        otherwise: (s) => s.notRequired()
    }),
    password: yup.string().when("option", {
        is       : "other",
        then     : (s) => s.required("Password is required"),
        otherwise: (s) => s.notRequired()
    }),
    security       : yup.string(),
    notify         : yup.string(),
    oauth_connected: yup.boolean().when("option", {
        is       : (value) => value !== "other",
        then     : (s) => s.oneOf([true], "Connect your account to continue"),
        otherwise: (s) => s.notRequired()
    }),
    test_to: yup.string().trim().required("Enter an email to send the test mail to").matches(EMAIL_REGEX.pattern, EMAIL_REGEX.msg)
});

export const smtpDefaults = {
    option         : "other",
    server         : "",
    username       : "",
    rate_limit     : "",
    from_name      : "",
    email          : "",
    port           : "587",
    password       : "",
    security       : "STARTTLS",
    notify         : "",
    oauth_connected: false,
    test_to        : ""
};

export const SERVER_OPTIONS = [
    { value: "other", label: "Other Mail server" },
    { value: "gmail", label: "Google Mail server (gmail)" },
    { value: "outlook", label: "Microsoft Mail server (outlook)" }
];

// Values are the backend's security_type enum (confirmed uppercase via a
// sample payload using "NONE") — labels stay user-friendly.
export const SECURITY_OPTIONS = [
    { value: "SSL", label: "SSL/TLS" },
    { value: "STARTTLS", label: "STARTTLS" },
    { value: "NONE", label: "Not Secure (No SSL)" }
];
